import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import {
  customizeVerticalScrollbarThumbMixin,
  disableSomeContentStyles
} from 'styles/mixins'
import styled, { css } from 'styled-components'
import { SMALL_MOBILE_HEIGHT } from './consts'

export const TtsTabWrapper = styled.div<{ $isDisabled: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      ${disableSomeContentStyles(0.5)}
    `}

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  }
`

export const SmallMobileOverflowWrapper = styled.div`
  @media screen and (max-height: ${SMALL_MOBILE_HEIGHT}px) {
    flex-grow: 1;
    overflow: hidden scroll;
    ${customizeVerticalScrollbarThumbMixin()}
  }
`
